import { t } from "i18next";
import MainPanelHeader from "../../layouts/mainPanelHeader";
import "./styles.scss";
import { useState } from "react";
import ExpSettingsItemTypes from "./components/exp-settings-itemtype";
import DBTab from "../../component/global/DBTab";
import FeaturesTab from "./components/features-tab";
import ItemsTab from "./components/items-tab";
import FormsTab from "./components/forms-tab";
import { HambergerMenu, Menu, UserSearch } from "iconsax-react";
import TemplateTab from "./components/template-tab";
import FeedbackPageTab from "./components/feedback-page-tab";
import SuperViserGroup from "../profile/SuperViserGroup";

export default function ExpSetting() {
    const [showSidebar, setShowSidebar] = useState(false);
    const [selectedTab, setSelectedTab] = useState(0);
    const [itemtype, setItemtype] = useState();
    const [fireItemTypeListRefresh, setFireItemTypeListRefresh] =
        useState(undefined);

    return (
        <div className="exp-settings">
            <MainPanelHeader
                panelType={t("Corpration.Panel.label")}
                panelName={t("Settings.exp.label")}
            />
            <div className="layout-container">
                <div className="right-column">
                    <div className="tab-section">
                        <DBTab
                            tabs={[
                                t("tab.templates"),
                                t("tab.features"),
                                t("tab.forms"),
                                t("tab.items"),
                                t("tab.feedback.page"),
                                t("tab.handling.groups"),
                            ]}
                            color="#2e71fc"
                            onChange={(e) => setSelectedTab(e)}
                            selected={selectedTab}
                        />
                        <button onClick={() => setShowSidebar(!showSidebar)}>
                            <HambergerMenu />
                        </button>
                    </div>
                    {selectedTab === 0 && (
                        <TemplateTab
                            onTemplateCreated={() =>
                                setFireItemTypeListRefresh(
                                    !fireItemTypeListRefresh
                                )
                            }
                        />
                    )}
                    {selectedTab === 1 && <FeaturesTab itemtype={itemtype} />}
                    {selectedTab === 2 && <FormsTab itemtype={itemtype} />}
                    {selectedTab === 3 && <ItemsTab itemtype={itemtype} />}
                    {selectedTab === 4 && <FeedbackPageTab />}
                    {selectedTab === 5 && (
                        <SuperViserGroup
                            form={{ id: sessionStorage.getItem("usercompany") }}
                        />
                    )}
                </div>
                <div className={`left-column ${showSidebar ? "show" : ""}`}>
                    <ExpSettingsItemTypes
                        onChange={(itemtype) => setItemtype(itemtype)}
                        selectedItemtype={itemtype}
                        itemTypeRefresh={fireItemTypeListRefresh}
                    />
                </div>
                <div
                    className={`back-drop ${showSidebar ? "show" : ""}`}
                    onClick={() => setShowSidebar(false)}
                ></div>
            </div>
            <style>
                {`
                .navbar-container {
                    display: none;
                }
                `}
            </style>
        </div>
    );
}
